import { component } from '../../decorators';

import WbHeader from '../header/header.vue';
import ClipMaker from '../../components/clip-maker/clip-maker.vue';

@component({
   name: 'CustomersClipMaker',
   components: { WbHeader, ClipMaker }
})
export default class CustomersClipMaker {
}
